import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Inspection } from '../../shared/interfaces';

@Component({
  selector: 'app-inspection-files-picker',
  templateUrl: './inspection-files-picker.component.html',
  styleUrls: ['./inspection-files-picker.component.scss'],
})
export class InspectionFilesPickerComponent implements OnInit {
  inspection;
  options = {};
  allowedFileExtensions = [];

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe(async (data: { inspection: Inspection }) => {
      if (data.inspection) {
        this.inspection = data.inspection;
      }
    });

    this.route.queryParams.subscribe(params => {
      const options = {};
      const allowedFileExtensions = [];
      for (const [key, value] of Object.entries(params)) {
        if (value === 'true') {
          options[key] = true;
        } else if (value === 'false') {
          options[key] = false;
        } else {
          options[key] = value;
        }
      }
      this.options = {
        ...options,
      };
      this.allowedFileExtensions = allowedFileExtensions;
    });
  }
}
